import { createApp } from "vue";
import router from "./router";
import store from "./store/index";
import ContactForm from "./components/others/ContactForm.vue";
import TourRegistrationForm from "./components/others/TourRegistrationForm.vue";
import GoodHostRegistration from "./components/good-host/GoodHostRegistration.vue";
import HikingFestivalRegistration from "./components/hiking-festival/HikingFestivalRegistration.vue";
import SummerFestRegistrationForm from "./components/others/SummerFestRegistrationForm.vue";
import SummerFestRegistrationSecondForm from "./components/others/SummerFestRegistrationSecondForm.vue";
import InformationBase from "./components/information-base/InformationBase.vue";
import CommercialProjects from "./components/commercial-projects/CommercialProjects.vue";
import UrlShortener from "./components/url-shortener/UrlShortener.vue";
import QrGenerator from "./components/qr-generator/QrGenerator.vue";
import vSelect from "vue-select";
import "./theme.js";
import "vue-select/dist/vue-select.css";

const app = createApp({});

app.use(router);
app.use(store);

app.component("info-contact-form", ContactForm);
app.component("info-tour-registration-form", TourRegistrationForm);
app.component("good-host-registration", GoodHostRegistration);
app.component("hiking-festival-registration", HikingFestivalRegistration);
app.component("festival-registration-form", SummerFestRegistrationForm);
app.component(
    "festival-registration-second-form",
    SummerFestRegistrationSecondForm
);
app.component("info-information-base", InformationBase);
app.component("info-commercial-projects", CommercialProjects);
app.component("url-shortener", UrlShortener);
app.component("qr-generator", QrGenerator);
app.component("v-select", vSelect);

app.mount("#app");
